<template>
  <div>
    <v-text-field
      v-if="imgUrlToEdit"
      v-model="imgUrlToEdit"
      @click:clear="clearImgUrl()"
      :label="label"
      prepend-icon="mdi-image-outline"
      chips
      clearable
      readonly
    />

    <v-file-input
      v-if="!imgUrlToEdit"
      v-model="imageFile"
      @change="uploadFile($event)"
      :display-size="1000"
      :disabled="uploading"
      :label="label"
      accept="image/*"
      placeholder="Upload an image"
      prepend-icon="mdi-image-outline"
      chips
      clearable
    />

    <v-container fluid class="ml-5 pr-5">
      <v-progress-circular
        v-if="uploading"
        :size="100"
        :width="15"
        :rotate="360"
        :value="progress"
      >
        {{ progress }}%
      </v-progress-circular>

      <img v-if="imgUrlToEdit" :src="imgUrlToEdit">

      <p v-if="imgUrlToEdit && itemToEdit.imgWidth && itemToEdit.imgHeight">
        Dimensions: {{ itemToEdit.imgWidth }} x {{ itemToEdit.imgHeight }}
      </p>
    </v-container>
  </div>
</template>

<script>
import { EventBus } from 'utils';

const { VUE_APP_CLOUDINARY_NAME, VUE_APP_CLOUDINARY_UPLOAD_PRESET } = process.env;
const CLOUDINARY_ENDPOINT = `https://api.cloudinary.com/v1_1/${VUE_APP_CLOUDINARY_NAME}/upload`;

export default {
  name: 'ImageUpload',

  props: {
    editedItem: {
      type: Object,
      default: () => ({}),
    },
    imgUrl: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Image Upload',
    },
  },

  data() {
    return {
      itemToEdit: null,
      imgUrlToEdit: null,
      imageFile: null,
      isImgUrlCleared: false,
      uploading: false,
      progress: 0,
      cloudinaryEndpoint: CLOUDINARY_ENDPOINT,
      cloudinaryPreset: VUE_APP_CLOUDINARY_UPLOAD_PRESET,
    };
  },

  watch: {
    editedItem: {
      handler() {
        if (!this.isImgUrlCleared) {
          this.imgUrlToEdit = this.imgUrl;
        }
      },
      deep: true,
    },
  },

  created() {
    this.itemToEdit = this.editedItem;
    this.imgUrlToEdit = this.imgUrl;
  },

  updated() {},

  methods: {
    clearImgUrl() {
      this.isImgUrlCleared = true;
      this.imgUrlToEdit = null;
      this.setImgUrl('');
    },
    /**
     * Based on Cloudinary's offical pure JS example: https://codepen.io/team/Cloudinary/pen/QgpyOK
     * https://cloudinary.com/documentation/upload_images#unsigned_upload
     * Cloudinary account under `tech+mda@upstatement.com`, credentials in 1pass
     * Upload settings page: https://cloudinary.com/console/settings/upload
     */
    uploadFile(file) {
      if (!file) {
        return;
      }

      this.isImgUrlCleared = false;
      this.uploading = true;

      const xhr = new XMLHttpRequest();
      let formData = new FormData();

      xhr.open('POST', this.cloudinaryEndpoint, true);

      // Update progress indicator
      xhr.upload.addEventListener(
        'progress',
        e => {
          const total = e.total;
          const loaded = e.loaded;
          this.progress = parseInt((100 / total) * loaded);
        },
        false,
      );

      xhr.onreadystatechange = () => {
        // File uploaded successfully
        if (xhr.readyState === 4 && xhr.status === 200) {
          this.uploading = false;
          this.progress = 0;
          formData = null;

          const response = JSON.parse(xhr.responseText);
          this.setImgFields(response);
        }
      };

      // Listen for error
      xhr.addEventListener(
        'error',
        e => {
          console.error('Image upload error', e);
          EventBus.$emit('alert-error', e);
        },
        false,
      );

      // The upload preset will automatically transform the image to be no larger than 600px
      formData.append('upload_preset', this.cloudinaryPreset);
      formData.append('file', file);
      xhr.send(formData);
    },

    setImgFields(response) {
      this.$emit('setImgFields', response);
    },

    setImgUrl(urlToEdit) {
      this.$emit('setImgUrl', urlToEdit);
    },
  },
};
</script>
